import React, {Component} from 'react'
import {connect} from 'react-redux'
import ViewTemplate from './ViewTemplate'
import ViewEdit from './ViewEdit'
import ViewDesign from './ViewDesign'
import ViewSettings from './ViewSettings'
import ViewPreview from './ViewPreview'

class SwitchViews extends Component {
    componentDidMount(){        
    }

    render(){
        const {settings} = this.props;
        if(!settings.form){
            return(<div form-empty></div>)
        }

        switch(settings.tab.name){
            case "templates":
                return (<ViewTemplate></ViewTemplate>)
            case "edit":
                return (<ViewEdit></ViewEdit>)
            case "design":
                return (<ViewDesign></ViewDesign>)
            case "settings":
                return (<ViewSettings></ViewSettings>)
            case "preview":
                return (<ViewPreview></ViewPreview>)
            default:
                return (
                    <div></div>
                )
        }
    }
}

const mapStateToProps = (state) => ({
    settings: state.settings    
})

const mapDispatchToProps = dispatch => ({

})

export default connect(mapStateToProps, null)(SwitchViews)